import { css } from '@emotion/css';
import {
  ColorsPrimary900,
  ColorsNeutral200,
  ColorsNeutral400,
  Spacings3,
  Spacings4,
  Spacings8,
  Radius2,
  TextTypographyHeading6,
  TextTypographyBody2,
} from '@efexteam/design-tokens';

const iconContainer = css({
  marginBottom: Spacings4,
  display: 'flex',
  justifyContent: 'center',
});

const iconWrapper = css({
  width: '60px',
  height: '60px',
  borderRadius: Radius2,
  border: `1px solid ${ColorsNeutral200}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const icon = css({
  '&&': {
    fontSize: '32px',
  },
});

const closeButton = css({
  '&&': {
    position: 'absolute',
    right: 10,
    top: 10,
  },
});

const dialogBody = css({
  textAlign: 'center',
});

const title = css({
  '&&': {
    ...TextTypographyHeading6,
    marginBottom: Spacings3,
  },
  color: ColorsPrimary900,
});

const description = css({
  color: ColorsNeutral400,
  lineHeight: 1.6,
  maxWidth: '400px',
  '&&': {
    marginBottom: Spacings8,
    ...TextTypographyBody2,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
});

const buttonContainer = css({
  marginTop: Spacings4,
});

const PasswordResetModalStyles = {
  iconContainer,
  iconWrapper,
  icon,
  title,
  description,
  buttonContainer,
  closeButton,
  dialogBody,
};

export default PasswordResetModalStyles;
